import { all } from 'redux-saga/effects';
import { sagas as commonSagas } from '@store/common';
import { sagas as MetricsChartContainerSagas } from '@store/metricsChartContainer';
import { sagas as filterContainerContainerSagas } from '@store/filterContainer';
import { sagas as errorDiagnosticsSagas } from '@store/errorDiagnostics';
import { sagas as dashboardSagas } from '@store/dashboards';
import { sagas as persistenceSagas } from '@store/persistentConfig';
import { sagas as comparisonSagas } from '@store/comparison';
import { sagas as trendsSagas } from '@store/trends';
import { sagas as compareSharingSagas } from '@store/comparison/sharing';
import { sagas as tempDashboard } from '@store/tempDashboard';
import { sagas as ViewerSessionsSagas } from '@store/viewerSessions';
import { sagas as adminSagas } from '@store/admin';
import { sagas as nocSagas } from '@store/noc';
import { sagas as errorConfigSagas } from '@store/errorLogicConfig';
import { sagas as metricLensSagas } from './store/metricLens';
import { sagas as timelineSagas } from './store/timeline';
import { sagas as policiesSaga } from './store/policies';
import { sagas as changeLogSagas } from './store/changeLog';
import { sagas as exportSagas } from './store/export';
import { sagas as sharedTabsSagas } from './store/sharedTabs';
import { sagas as overviewDashboardSagas } from './store/overviewDashboard';
import { sagas as serviceIntegrationsSagas } from './store/serviceIntegrations';
import { sagas as aiAlertsSagas } from './store/aiAlerts';
import { sagas as vmSagas } from './store/viewerModule';
import { sagas as tempDashboardTabSagas } from './store/tempDashboardTab';
import { sagas as appViewerSessionsSagas } from './store/appViewerSessions';

export default function* rootSaga() {
  yield all([
    ...filterContainerContainerSagas.map((saga) => saga()),
    ...commonSagas.map((saga) => saga()),
    ...MetricsChartContainerSagas.map((saga) => saga()),
    ...errorDiagnosticsSagas.map((saga) => saga()),
    ...dashboardSagas.map((saga) => saga()),
    ...persistenceSagas.map((saga) => saga()),
    ...comparisonSagas.map((saga) => saga()),
    ...trendsSagas.map((saga) => saga()),
    ...compareSharingSagas.map((saga) => saga()),
    ...tempDashboard.map((saga) => saga()),
    ...ViewerSessionsSagas.map((saga) => saga()),
    ...adminSagas.map((saga) => saga()),
    ...policiesSaga.map((saga) => saga()),
    ...changeLogSagas.map((saga) => saga()),
    ...sharedTabsSagas.map((saga) => saga()),
    ...exportSagas.map((saga) => saga()),
    ...timelineSagas.map((saga) => saga()),
    ...nocSagas.map((saga) => saga()),
    ...metricLensSagas.map((saga) => saga()),
    ...errorConfigSagas.map((saga) => saga()),
    ...overviewDashboardSagas.map((saga) => saga()),
    ...serviceIntegrationsSagas.map((saga) => saga()),
    ...aiAlertsSagas.map((saga) => saga()),
    ...vmSagas.map((saga) => saga()),
    ...tempDashboardTabSagas.map((saga) => saga()),
    ...appViewerSessionsSagas.map((saga) => saga()),
  ]);
}
